import { render, staticRenderFns } from "./servicePostMyCollect.vue?vue&type=template&id=1de6a7af&scoped=true&"
import script from "./servicePostMyCollect.vue?vue&type=script&lang=js&"
export * from "./servicePostMyCollect.vue?vue&type=script&lang=js&"
import style0 from "./servicePostMyCollect.vue?vue&type=style&index=0&id=1de6a7af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de6a7af",
  null
  
)

export default component.exports